var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1064,
    height: 804,
    viewBox: "0 0 1064 804",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M532 803.996C825.668 803.996 1063.73 785.828 1063.73 763.415C1063.73 741.003 825.668 722.835 532 722.835C238.331 722.835 0.265625 741.003 0.265625 763.415C0.265625 785.828 238.331 803.996 532 803.996Z",
    fill: "url(#paint0_radial_1083_4841)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_1083_4841)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.982 722.473V653.007L247.485 493.493L301.514 527.674L220.286 659.991L225.799 668.077H382.006V722.473H148.982ZM289.752 769.887V575.455H352.97V769.887H289.752Z",
    fill: "url(#paint1_linear_1083_4841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M530.73 777.238C508.922 777.238 490.3 773.807 474.863 766.946C459.426 759.84 446.807 750.284 437.006 738.278C427.205 726.026 419.976 712.06 415.321 696.378C410.665 680.451 408.337 663.789 408.337 646.391V625.074C408.337 600.571 412.748 578.396 421.569 558.548C430.39 538.701 443.867 522.896 461.999 511.135C480.131 499.373 503.042 493.493 530.73 493.493C558.418 493.493 581.206 499.373 599.093 511.135C617.226 522.896 630.702 538.701 639.523 558.548C648.344 578.396 652.755 600.571 652.755 625.074V646.391C652.755 663.789 650.427 680.451 645.772 696.378C641.116 712.06 633.888 726.026 624.086 738.278C614.53 750.284 602.034 759.84 586.597 766.946C571.16 773.807 552.538 777.238 530.73 777.238ZM530.73 714.02C548.862 714.02 562.339 707.649 571.16 694.907C579.981 682.166 584.392 662.563 584.392 636.1C584.392 607.922 579.858 587.707 570.792 575.455C561.726 562.959 548.372 556.71 530.73 556.71C512.843 556.71 499.366 562.959 490.3 575.455C481.234 587.707 476.701 607.677 476.701 635.365C476.701 662.073 481.111 681.921 489.932 694.907C498.999 707.649 512.598 714.02 530.73 714.02Z",
    fill: "url(#paint2_linear_1083_4841)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M681.995 722.473V653.007L780.497 493.493L834.526 527.674L753.299 659.991L758.812 668.077H915.019V722.473H681.995ZM822.765 769.887V575.455H885.983V769.887H822.765Z",
    fill: "url(#paint3_linear_1083_4841)"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_1083_4841)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1083_4841",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 148,
    y: 493,
    width: 768,
    height: 285
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M148.982 722.473V653.007L247.485 493.493L301.514 527.674L220.286 659.991L225.799 668.077H382.006V722.473H148.982ZM289.752 769.887V575.455H352.97V769.887H289.752Z",
    fill: "url(#paint4_linear_1083_4841)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M530.73 777.238C508.922 777.238 490.3 773.807 474.863 766.946C459.426 759.84 446.807 750.284 437.006 738.278C427.205 726.026 419.976 712.06 415.321 696.378C410.665 680.451 408.337 663.789 408.337 646.391V625.074C408.337 600.571 412.748 578.396 421.569 558.548C430.39 538.701 443.867 522.896 461.999 511.135C480.131 499.373 503.042 493.493 530.73 493.493C558.418 493.493 581.206 499.373 599.093 511.135C617.226 522.896 630.702 538.701 639.523 558.548C648.344 578.396 652.755 600.571 652.755 625.074V646.391C652.755 663.789 650.427 680.451 645.772 696.378C641.116 712.06 633.888 726.026 624.086 738.278C614.53 750.284 602.034 759.84 586.597 766.946C571.16 773.807 552.538 777.238 530.73 777.238ZM530.73 714.02C548.862 714.02 562.339 707.649 571.16 694.907C579.981 682.166 584.392 662.563 584.392 636.1C584.392 607.922 579.858 587.707 570.792 575.455C561.726 562.959 548.372 556.71 530.73 556.71C512.843 556.71 499.366 562.959 490.3 575.455C481.234 587.707 476.701 607.677 476.701 635.365C476.701 662.073 481.111 681.921 489.932 694.907C498.999 707.649 512.598 714.02 530.73 714.02Z",
    fill: "url(#paint5_linear_1083_4841)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M681.995 722.473V653.007L780.497 493.493L834.526 527.674L753.299 659.991L758.812 668.077H915.019V722.473H681.995ZM822.765 769.887V575.455H885.983V769.887H822.765Z",
    fill: "url(#paint6_linear_1083_4841)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1083_4841)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M203.45 686.807C207.585 692.668 214.566 697.861 225.096 701.681C242.012 707.819 256.537 708.731 268.909 706.191C281.281 703.65 291.564 697.644 299.973 689.845C310.13 680.428 317.539 668.409 322.561 656.793C310.293 635.92 294.966 624.996 279.391 620.878C260.664 615.926 241.388 620.764 226.328 630.323C211.242 639.898 200.568 654.087 198.837 667.628C197.975 674.37 199.324 680.959 203.45 686.807ZM323.523 654.502C311.158 634.076 295.749 623.134 279.903 618.944C260.525 613.821 240.681 618.845 225.257 628.634C209.859 638.406 198.684 653.05 196.853 667.374C195.933 674.565 197.375 681.666 201.816 687.96C206.248 694.242 213.614 699.643 224.413 703.561C241.624 709.806 256.526 710.775 269.311 708.15C282.095 705.525 292.698 699.319 301.333 691.312C311.328 682.044 318.699 670.352 323.797 658.949C325.804 662.535 327.723 666.399 329.541 670.556L331.374 669.754C329.306 665.029 327.107 660.668 324.794 656.655C327.95 649.184 330.13 641.917 331.437 635.628L329.478 635.221C328.274 641.02 326.314 647.656 323.523 654.502Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.862 536.781C211.998 542.641 218.978 547.834 229.508 551.655C246.424 557.793 260.95 558.704 273.321 556.164C285.693 553.624 295.976 547.617 304.385 539.819C314.542 530.401 321.951 518.382 326.973 506.766C314.705 485.893 299.378 474.969 283.803 470.851C265.076 465.899 245.801 470.738 230.74 480.296C215.654 489.871 204.98 504.06 203.249 517.601C202.387 524.343 203.736 530.932 207.862 536.781ZM327.935 504.476C315.57 484.05 300.161 473.107 284.315 468.917C264.937 463.794 245.093 468.818 229.669 478.607C214.271 488.38 203.096 503.023 201.265 517.347C200.346 524.538 201.787 531.639 206.228 537.934C210.661 544.215 218.026 549.616 228.826 553.535C246.036 559.779 260.938 560.749 273.723 558.123C286.507 555.498 297.111 549.292 305.745 541.285C315.74 532.017 323.111 520.326 328.21 508.922C330.216 512.508 332.135 516.372 333.954 520.529L335.786 519.728C333.718 515.002 331.519 510.642 329.206 506.629C332.362 499.158 334.542 491.891 335.849 485.601L333.891 485.194C332.686 490.994 330.726 497.629 327.935 504.476Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M432.26 789.465C445.567 808.323 467.903 824.856 501.265 836.961C554.713 856.353 600.738 859.279 640.038 851.209C679.339 843.139 711.979 824.06 738.634 799.343C771.078 769.258 794.641 730.833 810.517 693.811C771.657 627.241 722.874 592.249 673.079 579.083C613.562 563.347 552.412 578.743 504.72 609.011C457.002 639.297 422.941 684.349 417.396 727.718C414.627 749.374 418.962 770.619 432.26 789.465ZM811.491 691.519C772.531 625.403 723.664 590.389 673.591 577.15C613.424 561.242 551.704 576.823 503.648 607.323C455.619 637.805 421.057 683.312 415.412 727.465C412.585 749.569 417.013 771.326 430.626 790.618C444.23 809.897 466.951 826.638 500.583 838.841C554.325 858.34 600.727 861.323 640.44 853.168C680.153 845.014 713.114 825.735 739.994 800.809C772.277 770.873 795.805 732.78 811.766 695.966C818.871 708.33 825.637 721.764 832.01 736.329L833.842 735.528C827.219 720.389 820.168 706.459 812.751 693.673C822.822 670.014 829.768 646.966 833.905 627.045L831.947 626.639C827.911 646.07 821.189 668.483 811.491 691.519Z",
    fill: "white",
    fillOpacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M429.375 588.527C442.682 607.385 465.018 623.918 498.38 636.023C551.828 655.415 597.854 658.341 637.153 650.271C676.454 642.201 709.094 623.122 735.749 598.405C768.193 568.32 791.756 529.895 807.633 492.873C768.772 426.303 719.989 391.311 670.195 378.145C610.678 362.409 549.527 377.805 501.835 408.073C454.117 438.359 420.056 483.412 414.511 526.78C411.742 548.436 416.077 569.681 429.375 588.527ZM808.606 490.581C769.646 424.465 720.779 389.451 670.706 376.212C610.539 360.304 548.819 375.885 500.764 406.385C452.735 436.867 418.172 482.374 412.527 526.527C409.701 548.631 414.129 570.388 427.741 589.68C441.345 608.959 464.066 625.7 497.698 637.903C551.44 657.402 597.842 660.385 637.556 652.23C677.268 644.076 710.229 624.797 737.109 599.871C769.393 569.935 792.921 531.842 808.881 495.028C815.986 507.392 822.752 520.826 829.125 535.391L830.957 534.59C824.334 519.451 817.283 505.521 809.866 492.735C819.937 469.076 826.883 446.028 831.02 426.107L829.062 425.701C825.026 445.132 818.304 467.545 808.606 490.581Z",
    fill: "white",
    fillOpacity: 0.07
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M465.122 206.748H598.825L834.88 754.26H229.119L465.122 206.748Z",
    fill: "url(#paint7_linear_1083_4841)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M622.109 81.0768H460.213H450.974C450.974 70.4602 453.065 59.9475 457.128 50.1391C461.19 40.3306 467.145 31.4185 474.652 23.9114C489.814 8.75018 510.377 0.232683 531.818 0.232683C542.439 0.225874 552.957 2.31195 562.771 6.3717C572.586 10.4314 581.504 16.3853 589.017 23.893C596.529 31.4008 602.489 40.3153 606.555 50.1271C610.621 59.939 612.714 70.4558 612.714 81.0768H621.953H622.109Z",
    fill: "url(#paint8_linear_1083_4841)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M455.741 86.4712L455.741 81.077C455.741 61.67 463.451 43.0578 477.174 29.335C490.896 15.6121 509.509 7.90271 528.916 7.90271C548.323 7.90271 566.935 15.6121 580.658 29.335C594.381 43.0578 602.09 61.67 602.09 81.077L602.09 86.4712H455.741Z",
    fill: "url(#paint9_linear_1083_4841)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M444.34 81.077V86.5701H532.025H619.658V81.077H444.34Z",
    fill: "url(#paint10_linear_1083_4841)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M387.854 126.474C412.159 114.399 438.485 86.5701 438.485 86.5701H625.515C625.515 86.5701 651.841 114.399 676.146 126.474C700.451 138.549 763.105 146.581 763.105 146.581H300.688C300.688 146.581 363.497 138.549 387.854 126.474Z",
    fill: "url(#paint11_linear_1083_4841)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M613.65 206.748H450.303L422.163 184.775H641.841L613.65 206.748Z",
    fill: "#143D69"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M623.496 199.078L641.841 184.775H422.163L440.508 199.078H623.496Z",
    fill: "#FFC981"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M531.972 160.418H325.768C355.622 173.16 386.658 182.933 418.427 189.595H645.568C677.337 182.933 708.373 173.16 738.228 160.418H531.972Z",
    fill: "url(#paint12_linear_1083_4841)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M763.105 146.582H532.026H300.895H284.467L297.526 160.418H325.77H532.026H738.23H766.474L779.533 146.582H763.105Z",
    fill: "url(#paint13_linear_1083_4841)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M763.105 146.582H532.026H300.895H284.467L297.526 160.418H325.77H532.026H738.23H766.474L779.533 146.582H763.105Z",
    fill: "url(#paint14_linear_1083_4841)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M563.583 52.5225C570.624 52.5225 576.332 46.8148 576.332 39.774C576.332 32.7332 570.624 27.0255 563.583 27.0255C556.543 27.0255 550.835 32.7332 550.835 39.774C550.835 46.8148 556.543 52.5225 563.583 52.5225Z",
    fill: "white",
    fillOpacity: 0.16
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M572.086 60.244C572.086 62.294 572.694 64.2979 573.833 66.0023C574.972 67.7068 576.59 69.0352 578.484 69.8197C580.378 70.6042 582.462 70.8094 584.473 70.4095C586.483 70.0096 588.33 69.0224 589.779 67.5729C591.229 66.1234 592.216 64.2766 592.616 62.2661C593.016 60.2555 592.811 58.1715 592.026 56.2777C591.242 54.3838 589.913 52.765 588.209 51.6261C586.504 50.4873 584.5 49.8794 582.451 49.8794C579.702 49.8794 577.065 50.9714 575.122 52.9151C573.178 54.8589 572.086 57.4952 572.086 60.244Z",
    fill: "white",
    fillOpacity: 0.16
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_1083_4841",
    x: 148.982,
    y: 482.493,
    width: 766.036,
    height: 294.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.105882 0 0 0 0 0.247059 0 0 0 0 0.356863 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_1083_4841"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_1083_4841",
    x: 192.589,
    y: 489.493,
    width: 645.315,
    height: 291.745,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_1083_4841"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1083_4841",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(532 706.815) rotate(90) scale(97.1809 1273.38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19416C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#294E76",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1083_4841",
    x1: 530.464,
    y1: 423.448,
    x2: 530.464,
    y2: 703.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7974F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1083_4841",
    x1: 530.464,
    y1: 423.448,
    x2: 530.464,
    y2: 703.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7974F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1083_4841",
    x1: 530.464,
    y1: 423.448,
    x2: 530.464,
    y2: 703.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7974F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3F5B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1083_4841",
    x1: 530.464,
    y1: 423.448,
    x2: 530.464,
    y2: 918.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1083_4841",
    x1: 530.464,
    y1: 423.448,
    x2: 530.464,
    y2: 918.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1083_4841",
    x1: 530.464,
    y1: 423.448,
    x2: 530.464,
    y2: 918.887,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD1AF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7974F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1083_4841",
    x1: 523.371,
    y1: 650.361,
    x2: 523.371,
    y2: 77.1903,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7974F",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#F7974F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1083_4841",
    x1: 531.921,
    y1: 0.232666,
    x2: 531.921,
    y2: 121.015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC981",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1083_4841",
    x1: 528.915,
    y1: 7.90271,
    x2: 528.915,
    y2: 123.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B3F5B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B3F5B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1083_4841",
    x1: 531.999,
    y1: 81.077,
    x2: 531.999,
    y2: 86.5701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1083_4841",
    x1: 531.896,
    y1: 86.5701,
    x2: 531.896,
    y2: 289.139,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#143D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#143D69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1083_4841",
    x1: 531.998,
    y1: 208.46,
    x2: 531.998,
    y2: 47.8786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#143D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#143D69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1083_4841",
    x1: 532,
    y1: 146.582,
    x2: 532,
    y2: 160.418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#143D69"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#143D69",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1083_4841",
    x1: 532,
    y1: 146.582,
    x2: 532,
    y2: 169.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC981",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.42205924ee501e5ffa48dce3f9fb5785.svg";
export { ForwardRef as ReactComponent };